var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    staticStyle: {
      "margin-left": "20%"
    },
    attrs: {
      "label-width": "80px",
      model: _vm.form,
      "label-position": "left"
    }
  }, [_c("p", {
    staticStyle: {
      color: "#FF5050",
      "font-size": "12px"
    }
  }, [_vm._v("备注：以下所有内容必填")]), _c("el-form-item", {
    attrs: {
      label: "OPENID",
      "label-width": "100px"
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 3,
        maxRows: 5
      },
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.playerIDString,
      callback: function callback($$v) {
        _vm.playerIDString = $$v;
      },
      expression: "playerIDString"
    }
  }), _c("p", {
    staticStyle: {
      color: "#FF5050",
      "font-size": "12px"
    }
  }, [_vm._v("备注：OPENID之间,请用（英文逗号）隔开。必填")])], 1), _c("el-form-item", {
    attrs: {
      label: "封禁原因",
      "label-width": "100px"
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 3,
        maxRows: 5
      },
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.ban_reason,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ban_reason", $$v);
      },
      expression: "form.ban_reason"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "封禁时间/秒",
      "label-width": "100px"
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      type: "input",
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "time", $$v);
      },
      expression: "form.time"
    }
  }), _c("div", [_c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.setTime(1 * _vm.hour);
      }
    }
  }, [_vm._v("1小时")]), _c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.setTime(4 * _vm.hour);
      }
    }
  }, [_vm._v("4小时")]), _c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.setTime(1 * _vm.day);
      }
    }
  }, [_vm._v("1天")]), _c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.setTime(3 * _vm.day);
      }
    }
  }, [_vm._v("3天")]), _c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.setTime(0);
      }
    }
  }, [_vm._v("永久")])], 1)], 1)], 1), _c("div", {
    staticStyle: {
      "margin-left": "50%"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.preserBtn();
      }
    }
  }, [_vm._v("保 存")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };